import IMG1 from '../src/assets/tech/a-figma.svg'
import IMG2 from '../src/assets/tech/a-photoshop.svg'
import IMG3 from '../src/assets/tech/adobe-illustrator.png'
import IMG4 from '../src/assets/tech/adobe-xd.svg'
import IMG5 from '../src/assets/tech/adobi-id.png'
import IMG6 from '../src/assets/tech/bootstrap.svg'
import IMG7 from '../src/assets/tech/c-sass.png'
import IMG8 from '../src/assets/tech/react.svg'
import IMG9 from '../src/assets/tech/git.svg'
import IMG10 from '../src/assets/tech/node.png'
import IMG11 from '../src/assets/tech/css3.svg'
import IMG12 from '../src/assets/tech/html5.svg'
import IMG13 from '../src/assets/tech/javascript.png'
import IMG14 from '../src/assets/tech/jest.png'
import IMG15 from '../src/assets/tech/mongodb.png'
import IMG16 from '../src/assets/tech/mysql.png'
// import IMG17 from '../src/assets/tech/express.png'
import IMG18 from '../src/assets/tech/postgresql.svg'
import IMG19 from '../src/assets/tech/nextJS.png'

import IMG21 from '../src/assets/tech/rails.svg'
import IMG22 from '../src/assets/tech/command.png'
import IMG23 from '../src/assets/tech/ruby.svg'
import IMG24 from '../src/assets/tech/vscode.svg'

// import IMG26 from '../src/assets/tech/webpack.svg'
import IMG27 from '../src/assets/tech/github.png'
import IMG28 from '../src/assets/tech/rspec.png'
import IMG29 from '../src/assets/tech/grafQL.png'
import IMG30 from '../src/assets/tech/firebase.png'
import IMG31 from '../src/assets/tech/api.svg'
import IMG32 from '../src/assets/tech/postman.svg'

// import IMG19 from '../src/assets/tech/python.png'   *** I WILL ADD AFTER FINISH LEARNING ***
// import IMG from '../src/assets/tech'

const Technologies = [
  {
    id: 1,
    title: 'Figma',
    image: IMG1,
  },
  {
    id: 2,
    title: 'Photoshop',
    image: IMG2,
  },
  {
    id: 3,
    title: 'Illustrator',
    image: IMG3,
  },
  {
    id: 4,
    title: 'Adobi-XD',
    image: IMG4,
  },
  {
    id: 5,
    title: 'Adobi-ID',
    image: IMG5,
  },
  {
    id: 6,
    title: 'Bootstrap',
    image: IMG6,
  },
  {
    id: 7,
    title: 'SASS',
    image: IMG7,
  },
  {
    id: 8,
    title: 'React',
    image: IMG8,
  },

  {
    id: 9,
    title: 'CSS3',
    image: IMG9,
  },
  {
    id: 10,
    title: 'Node',
    image: IMG10,
  },
  {
    id: 11,
    title: 'Git',
    image: IMG11,
  },
  {
    id: 12,
    title: 'HTML5',
    image: IMG12,
  },
  {
    id: 13,
    title: 'JavaScript',
    image: IMG13,
  },
  {
    id: 14,
    title: 'Jest',
    image: IMG14,
  },
  {
    id: 15,
    title: 'MongoDB',
    image: IMG15,
  },
  {
    id: 16,
    title: 'My.SQL',
    image: IMG16,
  },
  // {
  //   id: 17,
  //   title: 'Express.js',
  //   image: IMG17,
  // },
  {
    id: 18,
    title: 'PostGreSQL',
    image: IMG18,
  },
  {
    id: 19,
    title: 'Next',
    image: IMG19,
  },

  {
    id: 21,
    title: 'Rails',
    image: IMG21,
  },

  {
    id: 22,
    title: 'CommandLine',
    image: IMG22,
  },
  {
    id: 23,
    title: 'Ruby',
    image: IMG23,
  },
  {
    id: 24,
    title: 'VsCode',
    image: IMG24,
  },
  // {
  //   id: 26,
  //   title: 'WebPack',
  //   image: IMG26,
  // },
  {
    id: 27,
    title: 'Github',
    image: IMG27,
  },
  {
    id: 28,
    title: 'Rspec',
    image: IMG28,
  },
  {
    id: 29,
    title: 'GrafQL',
    image: IMG29,
  },
  {
    id: 30,
    title: 'FireBase',
    image: IMG30,
  },
  {
    id: 31,
    title: 'API',
    image: IMG31,
  },
  {
    id: 32,
    title: 'API',
    image: IMG32,
  },

  //  *** I WILL ADD AFTER FINISH LEARNING ***
  // {
  //   id: 31,
  //   title: 'Python',
  //   image: IMG19,
  // },
]

export default Technologies
